import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20.32" height="13.828" viewBox="0 0 20.32 13.828">
            <path id="mail001_-_E02D" data-name="mail001 - E02D" d="M-18.78-42.78v13.828H1.54V-42.78Zm10.16,8.261-8.6-7.417h17.2Zm-3.214-1.655-6.1,5.81V-41.433Zm6.427,0L.7-41.433v11.069Zm-5.778.552,2.564,2.207,2.564-2.207L.063-29.8H-17.3Z" transform="translate(18.78 42.78)"/>
        </svg>
    );
}